import clsx from "clsx"

const Logo = ({ className }: { className?: string }) => (
  <div className={clsx("flex items-center leading-none", className)}>
    crypto
    <span className="opacity-25">|</span>
    <span className="text-teal-300">email</span>
    <span className="opacity-25">|</span>
    alerts
  </div>
)

export default Logo
